import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAssistant } from '@/types/assistants';
import { RootState } from "@/store/index.ts";
import {assistantApi} from "@/api/assistants.ts";

interface AssistantState {
    assistant: IAssistant | null;
    loading: boolean;
    error: string | null;
}

const initialState: AssistantState = {
    assistant: null,
    loading: false,
    error: null,
};

export const fetchAssistant = createAsyncThunk(
    'logs/fetchAssistant',
    async (id: number, { getState, rejectWithValue }) => {
        const state = getState() as RootState;
        if (state.assistant.assistant && state.assistant.assistant.ID === id) {
            return state.assistant.assistant;
        }
        try {
            const response = await assistantApi.getAll();
            const assistant = response.data.find((i: IAssistant) => i.ID === id);
            return { ...assistant }
        } catch (error: any) {
            return rejectWithValue(error.message || 'Ошибка загрузки ассистента');
        }
    }
);

const assistantSlice = createSlice({
    name: 'assistants',
    initialState,
    reducers: {
        setCurrentAssistant: (state, action: PayloadAction<any>) => {
            console.log(state)
            state.assistant = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAssistant.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchAssistant.fulfilled, (state, action: PayloadAction<any>) => {
                state.assistant = action.payload;
                state.loading = false;
            })
            .addCase(fetchAssistant.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
    }
});

export const {
    setCurrentAssistant,
} = assistantSlice.actions;

export default assistantSlice.reducer;
